module.exports = __webpack_public_path__ + "img/convenio-de-practicas5.f8a2f2ca.png";